module.exports = "<mat-form-field>\n  <input matInput name=\"{{name}}\" type=\"number\" placeholder=\"{{placeholder}}\" [ngModel]=\"value\" (ngModelChange)=\"change($event)\" \n    [readonly]=\"readonly\" max=\"{{max}}\" \n    onkeydown=\"javascript: return event.keyCode == 69 ? false : true\"\n    onKeyPress=\"if(this.value.length==5) return false;\" min=\"0\">\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-number/bra-number.component.html
// module id = ../../../../../src/app/componentes/bra-number/bra-number.component.html
// module chunks = main